import React, { useMemo } from 'react';
import { CreditApprovalRound } from '@indigo-ag/schema';
import ConditionalsEdit from '../../features/collateral-analysis/sections/ConditionalsValidation/ConditionalsEdit';
import { utils } from 'shared';
import {
  createFromCreditApprovalData,
  createFromImportedConditionals
} from '../../features/collateral-analysis/sections/ConditionalsValidation/ConditionalsEdit.utils';

interface EditCreditConditionalsProps {
  round?: CreditApprovalRound;
  initialConditionals: string[];
}

export const EditCreditConditionals = ({ round, initialConditionals }: EditCreditConditionalsProps) => {
  const conditionals = useMemo(() => {
    if (!round || round.creditConditionals.length === 0) return createFromImportedConditionals(initialConditionals);
    return createFromCreditApprovalData(round.creditConditionals);
  }, [round, initialConditionals]);

  if (utils.CreditApprovalUtil.isRoundComplete(round) || !round) return null;

  return <ConditionalsEdit roundId={round.id} data={conditionals} alreadyAdded={initialConditionals} />;
};
